var moduleName = "pharmacist.hmr";

const $inject = ["$http"];

/**
 * Pharmacist
 */
class PharmacistService {
  /**
   * Init
   * @param $http
   */
  constructor($http) {
    this.http = $http;

    this.getPharmacistCache = null;

    this.setPharmacistCache = function (response) {
      if (!response.data.error && response.data.data.pharmacist) {
        this.getPharmacistCache = response;
      }
    };
  }

  /**
   * Get information about the current pharmacist
   * @param {Function} handleSuccess
   * @param {Function} handleError
   * @param {Boolean} forceRefresh
   */
  get(handleSuccess, handleError, forceRefresh) {
    var self = this;
    if (!this.getPharmacistCache || forceRefresh) {
      this.http.get("/app/pharmacist/").then(function (response) {
        self.setPharmacistCache(response);
        handleSuccess(response);
      }, handleError);
    }
    else {
      handleSuccess(this.getPharmacistCache);
    }
  }

  /**
   *Update details info
   * @param {Array} pharmacist
   * @param {Function} handleSuccess
   * @param {Function} handleError
   */
  update(pharmacist, handleSuccess, handleError) {
    this.http.post("/app/pharmacist/update", {pharmacist: pharmacist}).then(handleSuccess, handleError);
  }

  /**
   * Upload new documents
   * @param pharmacist
   * @param handleSuccess
   * @param handleError
   */
  updateAccreditation(pharmacist, handleSuccess, handleError) {
    this.http.post("/app/pharmacist/updateAccreditation", {pharmacist: pharmacist}).then(handleSuccess, handleError);
  }
}

/**
 * Dependencies
 */
PharmacistService.$inject = $inject;

/**
 * Add to angular and make available
 */
export default angular.module(moduleName, [])
  .service("PharmacistService", PharmacistService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/pharmacist.service.js
 **/